
document.addEventListener('DOMContentLoaded', function() {

    // axios を require してインスタンスを生成する
    const axiosBase = require('axios');
    const axios = axiosBase.create({
        baseURL: apiHost,
        // headers: {
        //     'Content-Type': 'application/json',
        //     'X-Requested-With': 'XMLHttpRequest'
        // },
        // responseType: 'json'  
    });

    const slideShow = function(){
        const target = document.getElementsByClassName('-slideShow');
        const position = Math.floor(window.innerHeight * .75);
        for (let i = 0; i < target.length; i++) {
            let offsetTop = Math.floor(target[i].getBoundingClientRect().top);
            if (offsetTop < position) {
                target[i].classList.add('-isShow');
            }
        }
    }
    window.addEventListener('scroll', slideShow, false);

    
    // const targets = document.getElementsByClassName('fade');
    // for(let i = targets.length; i--;){
    // let observer = new IntersectionObserver((entries, observer) => {
    // for(let j = entries.length; j--;){
    // if (entries[j].isIntersecting) {
    //     entries[j].target.classList.add('active');
    //     observer.unobserve(entries[j].target);
    // }
    // }
    // });
    // observer.observe(targets[i]);
    // }

    const stickHeader = function(){
        const target = document.getElementById('js-body');
        const position = Math.floor(-150);
        
        let offsetTop = Math.floor(target.getBoundingClientRect().top);
        if (offsetTop < position) {
            target.classList.add('-isStatic');
        }else{
            target.classList.remove('-isStatic');
        }
        
    }
    window.addEventListener('scroll', stickHeader, false);


    const vueTemplate = document.getElementById('js-body');
    const vueWapper = ({
        data() {
            return {

                showLoading: false,
                removeLoading: false,
                isHamburgerOpen: false,
                scrollY: 0,
                mql: null,

                pathName: '',

                currentSection: 1,

                topicsShowLength: 90,
                topicsLength: 0,
                topicsMaxPage: 0,
                topicsCurrentPage: 1,
                topicsCategory: null,
                topics: [],
                hasParam: false,

                categories : 
                    {
                        info: 3,
                        activities: 4,
                        symposium: 5
                    },

                isShowVideo: false,
                videoId: null


            }
        },
        created() {

            this.pathName = location.pathname;
            var urlHash = location.hash;
            if(urlHash){ this.smoothScroll(urlHash) }

            
        },
        beforeUnmount(){
            this.closeNavigation()
            this.mql.removeListener(this.setNavigationStatus)
        },
        mounted() {
        //   window.addEventListener('hashchange', this.parseHash);
        //   this.parseHash();
          this.parsParam();

            this.$nextTick(function () {
                this.mql = window.matchMedia( '(mix-width: 1024px)' )
                this.mql.addListener(this.setNavigationStatus)
                this.setNavigationStatus()

                const topicsDom = document.getElementById('js-topics');
                  if( topicsDom ){ 
                      this.loadTopics('first') 
                  }

                  const topTopicsDom = document.getElementById('js-top-topics');
                  if( topTopicsDom ){ 
                      this.topicsShowLength = 3
                      this.loadTopics('first') 
                  }
                  
                //   const contactDom = document.getElementById('js-g_form');
                //   if( contactDom ){ 
                //     contactDom.style.height = contactDom.contentWindow.document.body.scrollHeight + "px";
                //   }
            })
        },
        computed: {
          setData() {
              return function (date) {
                  const formattedDate = date.slice(0, 10).replace(/-/g, '/');
                  return formattedDate;
              }
          },
        },
        methods: {
          closeVideo(){
            this.videoId = null;
            this.isShowVideo = false;
          },
          popUpSelectedVideo(video_code){
            this.videoId = video_code;
            this.isShowVideo = true;

          },
          async loadTopics(action){
            this.message = null
              let callLength = this.topicsShowLength
              if( action == 'first'  ){
                  if(this.hasParam){
                      callLength = this.topicsShowLength * this.topicsCurrentPage
                      this.topicsCurrentPage = 1
                  } 
              }else{
                  location.href="#tp="+this.topicsCurrentPage
                  this.topicsCurrentPage ++
              }
              if( ~location.pathname.indexOf('/activities/symposium.html')){
                this.topicsCategory = 'symposium'
              }
              let p = this;
              await axios.get('?rest_route=/wp/v2/posts&_embed', {
                      params: {
                          categories: this.categories[this.topicsCategory],
                          per_page : callLength,
                          page : this.topicsCurrentPage,
                          status : 'publish'
                      }
                  }
              )
              .then(res => {
                  p.topics = p.topics.concat(res.data)  
                  p.topicsMaxPage = res.headers['x-wp-totalpages']
                  if( p.topicsMaxPage == 0 ){
                    p.message = "まだ投稿がありません"
                  }else{
                    
                    p.LoadListner()
                    
                    if( p.hasParam && action != 'more' ){
                        p.topicsCurrentPage = 1
                        p.hasParam = false
                    }

                    const hash = location.hash;
                    if(hash) {
                        this.$nextTick(function() {
                            this.smoothScroll(hash);
                        })
                    }
                  }
              })
              .catch(error => {
                  p.message = 'Topicsが取得できませんでした。<br>しばらくしてからもう一度アクセスいただくよう、お願いいたします。'
              })
              return p
          },
          parseHash: function() {
              const hash = location.hash.substr(1);
              const hashes = hash.split(',');
              for(let i = 0 ; i < hashes.length ; i++) {

                  let hashKeyValue = hashes[i].split('=');
                  let value = hashKeyValue[1];

                  if( value) {
                          this.topicsCurrentPage = parseInt(value);
                          this.hasParam = true
                  }
              }
          },
          parsParam: function() {
            const hash = location.search.substr(1);
            const hashes = hash.split('&');
            for(let i = 0 ; i < hashes.length ; i++) {

                let hashKeyValue = hashes[i].split('=');
                let key = hashKeyValue[0];
                let value = hashKeyValue[1];

                if( key == 'category') {
                  this.topicsCategory = value
                }
            }

          },
            smoothScroll(hash, section){
                const duration = 500;
                const Ease = {
                    easeInOut: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1
                }

                const current_p = document.documentElement.scrollTop || document.body.scrollTop;
                hash = hash.replace('#', '');

                if( hash == 'top' ){
                    window.scrollTo({
                          top: 0,
                          behavior: "smooth"
                      });
                }else{
                  const header = document.getElementById('js-header');
                  const header_h = header.clientHeight;
                  const smoothScrollTriggers = document.getElementById(hash);

                  if (smoothScrollTriggers) {
                      let margin = 0
                      const target_p = window.pageYOffset + smoothScrollTriggers.getBoundingClientRect().top - header_h - margin; //少し余白持たせる
                      const startTime = performance.now()
                      const p = this
                      const loop = function (nowTime) {
                          const time = nowTime - startTime
                          const normalizedTime = time / duration
                          if (normalizedTime < 1) {
                              window.scrollTo(0, current_p + ((target_p - current_p) * Ease.easeInOut(normalizedTime)))
                              requestAnimationFrame(loop)
                              p.currentSection = section
                          }
                      }
                      requestAnimationFrame(loop)
                  }
                }
                
            },
            switchNavigation(){
                this.isHamburgerOpen = !this.isHamburgerOpen
            },
            closeNavigation(){
                if(!this.mql.matches) {
                    this.isHamburgerOpen = false
                }
            },
            setNavigationStatus() {
                if(this.mql.matches) {
                    this.closeNavigation()
                } else {
                    this.isHamburgerOpen = false
                }
            }
        }
    });

    if ( vueTemplate ) {
        Vue.createApp(vueWapper).mount('#js-body');
    }
  
  
    //- ハンバーガーメニュー
    const globalHeaderTemplate = document.getElementById('js-global-header');
    if ( globalHeaderTemplate ) {
        new Vue({
            el: '#js-global-header',
            data() {
                return {
                    isHamburgerOpen: false,
                    scrollY: 0,
                    mql: null,

                    pathName: ''
                }
            },
            created() {
                this.pathName = location.pathname;
            },
            beforeDestroy(){
                this.closeNavigation()

                this.mql.removeListener(this.setNavigationStatus)
            },
            mounted() {
                this.mql = window.matchMedia( '(min-width: 961px)' )
                this.mql.addListener(this.setNavigationStatus)
                this.setNavigationStatus()
            },
            methods: {
                switchNavigation(){
                    this.isHamburgerOpen = !this.isHamburgerOpen

                    const body = document.body

                    if( this.isHamburgerOpen ) {
                        this.scrollY = window.pageYOffset
                        // 変更箇所: position: fixedをoverflow: hiddenに変更
                        body.style.overflow = 'hidden'
                        // body.style.position = 'fixed'
                        body.style.top = '-' + this.scrollY + 'px'
                        body.style.width = '100%'
                        document.removeEventListener('scroll', resizeLogo); // スクロールイベント削除
                    } else {
                        // 変更箇所: position, top, widthのリセットをoverflowのリセットに変更
                        body.style.overflow = '';
                        // body.style.position = ''
                        // body.style.top = ''
                        // body.style.width = ''
                        window.scrollTo(0, this.scrollY)
                        this.scrollY = 0
                        document.addEventListener('scroll', resizeLogo); // ハンバーガーメニューが閉じた場合はスクロールイベントを追加
                    }
                },
                closeNavigation(){
                    if(!this.mql.matches) {
                        this.isHamburgerOpen = false

                        this.resetBody()
                    }
                },
                resetBody() {
                    const body = document.body
                    // 変更箇所: position, top, widthのリセットをoverflowのリセットに変更
                    body.style.overflow = ''
                    // body.style.position = ''
                    // body.style.top = ''
                    // body.style.width = ''
                },
                setNavigationStatus() {
                    if(this.mql.matches) {
                        this.isHamburgerOpen = false
                        this.resetBody()
                    } else {
                        this.closeNavigation()
                    }
                }
            }
        });
    }


// news
    const url = "https://api.sssapi.app/mMxiX-svH71oO8v94uXS6";

    // jsonデータ（スプレッドシートの内容をWebで読み込めるように変更したデータ）を読み込みます
    async function resJson() {
        const res = await fetch(url);
        const news = await res.json();
        return news;
    }

    // スプレッドシートのお知らせの行数を取得し、お知らせを差し込むためのエリアを増やします
    function newsClone(news) {
        console.log(news);
        const contents = document.querySelector(".news-contents");
        for (let i = 1; i < Math.min(news.length, 3); i++) {
            let clone = contents.firstElementChild.cloneNode(true);
            contents.appendChild(clone);
        }
    }
        // 上記で取得したエリアに内容を流し込み
    function newsInput(news) {
        console.log(news);
        const newsDate = document.querySelectorAll(".news-date");
        const newsTag = document.querySelectorAll(".news-tag");
        const newsText = document.querySelectorAll(".news-text");
        const newsLink = document.querySelectorAll(".news-link");
        for (let i = 0; i < news.length; i++) {
            newsDate[i].innerHTML = news[i].date;
            newsTag[i].innerHTML = news[i].tag;
            newsText[i].innerHTML = news[i].text;
            
            if (newsLink[i]) {
                if (news[i].link != null) {
                    newsLink[i].setAttribute("href", news[i].link);
                    newsText[i].innerHTML += ` 　<span class="details-link"> > 詳しくみる</span>`;
                } else {
                    newsLink[i].setAttribute("href", news[i].link);
                    newsLink[i].removeAttribute("href"); // リンクを無効化
                    newsLink[i].style.pointerEvents = "none"; // カーソルイベントを無効化
                }
            }
        }
    }

    // 今までの関数を実行します
    async function allNews() {
        const news = await resJson();
        newsClone(news);
        newsInput(news);
    }

    allNews();

    //newsここまで

//動くロゴ

    let isSmall = false;

    function resizeLogo() {
        const logo = document.getElementById('img-logo');
        const scrollPosition = window.scrollY;
        const triggerPosition = 10; // アニメーションを発火させるスクロール位置
        const isMobile = window.matchMedia('(max-width: 420px)').matches; // スマホ対応


        if (scrollPosition > triggerPosition && !isSmall) { //小さくする条件
            isSmall = true;
            logo.style.paddingTop = '0px'; // なぜかわからないけど必要
            logo.style.width = '17%'; 
            logo.style.minWidth = '110px';
            logo.style.height = 'auto'
            if (isMobile) {
                logo.style.top = '-2.0em'; // スマホ画面の場合
            } else {
                logo.style.top = '-4em'; // ロゴを上に移動
            }
        } else if (scrollPosition <= triggerPosition && isSmall) { //元に戻す条件
            isSmall = false;
            logo.style.width = '100%';
            if (isMobile) {
                logo.style.top = '120px'; // スマホ画面の場合
            } else {
                logo.style.top = '100px'; // ロゴを元の位置に戻す
            }
        }
    }

    document.addEventListener('scroll', resizeLogo); //- 初期設定ではスクロールイベントをオン。ハンバーガーメニューの箇所で切り替えを追加記述しています。


    //動くロゴここまで

//スライダー

    let slidesToShowNum = 4; //slidesToShowに設定したい値
    /* slidesToShowより投稿が少ない場合の処理を記述 */
    let item = $('.top-works .slider .item').length; //スライド内の画像の個数を取得
    if (item < slidesToShowNum) {
        for (i = 0; i <= slidesToShowNum + 1 - item; i++) { //足りていない要素数分、後ろに複製
            $('.top-works .slider .item:nth-child(' + i + ')').clone().appendTo('.top-works .slider');
        }
    }
    //今は使ってない

    $('.top-works .slider').slick({
            arrows: false,//左右の矢印はなし
            autoplay: true,//自動的に動き出すか。初期値はfalse。
            autoplaySpeed: 0,//自動的に動き出す待ち時間。初期値は3000ですが今回の見せ方では0
            speed: 6900,//スライドのスピード。初期値は300。
            infinite: true,//スライドをループさせるかどうか。初期値はtrue。
            pauseOnHover: false,//オンマウスでスライドを一時停止させるかどうか。初期値はtrue。
            pauseOnFocus: false,//フォーカスした際にスライドを一時停止させるかどうか。初期値はtrue。
            cssEase: 'linear',//動き方。初期値はeaseですが、スムースな動きで見せたいのでlinear
            //slidesToShow: slidesToShowNum,//スライドを画面に4枚見せる
            slidesToScroll: 1,//1回のスライドで動かす要素数
            useTransform: false,
            variableWidth: true, //スライド幅の自動計算を無効に
            swipe: false, //スワイプを無効に
            responsive: [
                {
                breakpoint: 769,//モニターの横幅が769px以下の見せ方
                settings: {
                    //slidesToShow: 2,//スライドを画面に2枚見せる
                    //↑スライド幅の自動計算を無効にしたので省略します
                }
            }
        ]
        });

        //TOPの下部、トピックスのスライダー

    $('.top-topics .slider').slick({
            dots: true,
            arrows: false,//左右の矢印はなし
            autoplay: true,//自動的に動き出すか。初期値はfalse。
            autoplaySpeed: 1200,//自動的に動き出す待ち時間。初期値は3000ですが今回の見せ方では0
            speed: 1000,//スライドのスピード。初期値は300。
            infinite: true,//スライドをループさせるかどうか。初期値はtrue。
            //pauseOnHover: false,//オンマウスでスライドを一時停止させるかどうか。初期値はtrue。
            pauseOnFocus: false,//フォーカスした際にスライドを一時停止させるかどうか。初期値はtrue。
            //cssEase: 'linear',//動き方。初期値はeaseですが、スムースな動きで見せたいのでlinear
            slidesToShow: 1,//スライドを画面にn枚見せる
            slidesToScroll: 1,//1回のスライドで動かす要素数
            //useTransform: false,
            //centerMode: true,
            //centerPadding: "15%",
            //useTransform: false,
            swipe: false, //スワイプを無効に
        });


    //スライダーここまで


//スライドイン
    let winHeight,winScroll,scrollPos;
    $(window).on('load scroll',function(){
        winScroll = $(window).scrollTop();
        winHeight = $(window).height();
        scrollPos = winHeight * 0.9 + winScroll;
        $(".slidein").each(function(){
            if($(this).offset().top <= scrollPos){
                $(this).addClass("show");
            }else{
                $(this).removeClass("show");
            }
        });
    });
    //スライドインここまで


//お問い合わせのテキストボックス
    $(function() {
        var $textarea = $('.contactForm textarea');
        var lineHeight = parseInt($textarea.css('lineHeight'));
        $textarea.on('input', function(e) {
            var lines = ($(this).val() + '\n').match(/\n/g).length;
            $(this).height(lineHeight * lines);
        });
    });

    // お問い合わせのテキストボックスここまで

//ポップアップウィンドウ
$(function() {
    $('.open-modal').on('click', function () {
        const targetModal = $(this).data('modal');
        $(targetModal).addClass('active');
        $('body').addClass('modal-open');
    });

    $('.close-modal, .modal').on('click', function (e) {
        if (
            e.target === this ||
            $(e.target).closest('.close-modal').length
        ) {
            $(this).closest('.modal').removeClass('active');
            $('body').removeClass('modal-open');
        }
    });
});

    // ポップアップウィンドウここまで


});

